module.exports = __webpack_public_path__ + "static/media/arrow-left-white.d975c00c.svg";